import React from 'react'
import NewUser from '../components/NewUser'

const NewUserPage = () => {
  return (
    <div>
      <NewUser/>
    </div>
  )
}

export default NewUserPage